import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, inject, input, signal } from '@angular/core';
import { TranslatePipe } from 'app/core/i18n/translate.pipe';
import { AssignedPartnersPanelComponent } from './assigned-partners-panel/assigned-partners-panel.component';
import { SubRoutePartnersLayoutService } from './sub-route-partners-layout.service';
import { UnassignedPartnersSidebarComponent } from './unassigned-partners-sidebar/unassigned-partners-sidebar.component';

/**
 * Layout component for sub-route partners management.
 * Contains the sidebar (unassigned) and main panel (assigned).
 * On mobile (< md breakpoint), uses tab-based navigation.
 */
@Component({
  selector: 'app-sub-route-partners-layout',
  standalone: true,
  imports: [CommonModule, AssignedPartnersPanelComponent, UnassignedPartnersSidebarComponent, TranslatePipe],
  providers: [SubRoutePartnersLayoutService],
  templateUrl: './sub-route-partners-layout.component.html',
  styles: [
    `
      :host {
        display: block;
        height: 100%;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubRoutePartnersLayoutComponent {
  private layoutService = inject(SubRoutePartnersLayoutService);

  // Input signal requerido
  subRouteId = input.required<string>();

  // Mobile tab navigation
  activeTab = signal<'unassigned' | 'assigned'>('assigned');

  constructor() {
    // Sync subRouteId with the layout service
    effect(
      () => {
        const id = this.subRouteId();
        if (id) {
          this.layoutService.setSubRouteId$.next(id);
        }
      },
      { allowSignalWrites: true }
    );
  }

  setActiveTab(tab: 'unassigned' | 'assigned'): void {
    this.activeTab.set(tab);
  }
}
